import { render, staticRenderFns } from "./AccountDelete.vue?vue&type=template&id=bad462ae&scoped=true"
import script from "./AccountDelete.vue?vue&type=script&lang=js"
export * from "./AccountDelete.vue?vue&type=script&lang=js"
import style0 from "./AccountDelete.vue?vue&type=style&index=0&id=bad462ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad462ae",
  null
  
)

export default component.exports